module.exports = __webpack_public_path__ + "img/success.41c2369.svg";